module.exports = __webpack_public_path__ + "img/Logo.2d851235.svg";